var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDarkGlobe(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 77 77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #02222b;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-3 {\n        fill: #00dc92;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M38.5,6c17.9,0,32.5,14.6,32.5,32.5s-14.6,32.5-32.5,32.5S6,56.4,6,38.5,20.6,6,38.5,6M38.5,0C17.2,0,0,17.2,0,38.5s17.2,38.5,38.5,38.5,38.5-17.2,38.5-38.5S59.8,0,38.5,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.5,74.1c-19.7,0-35.6-15.9-35.6-35.6S18.8,2.9,38.5,2.9s35.6,15.9,35.6,35.6-15.9,35.6-35.6,35.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M69.4,56.2s-2.3-.8-3.3-6.7-1-11.3-4.5-12.2-4.9,3-8.4,0-7.9-4.5-4.9-10.3,1.9-6.9,6.9-6.9,6.4,1,9.8,0,1.9-1.5,0-3-4.9,0-8.8,0-7.3,6.9-8.8,5.8-2.4-2.3,0-6.6,4.4-4.2,4.9-7.2-3.9-4.8-3.9-4.8c0,0,17.2,3.6,24.2,22.7,5.5,15.2-3.2,29.1-3.2,29.1v-.2c0,0,0,.2,0,.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M40.4,72.5c1.4.2,2.4-1.1,2-2.3-.4-1.7-.6-4,1-5.8,2.9-3.3,4.6-6.2,5-9.9s2-3.7-3.1-5.4c-5.1-1.6-8.1-4.1-11.4-3.3-3.3.8-3.9,2-7-.2-1.8-1.3-6.3,1.9-6.3-2.2s5-2.9,6.2-4.6.8-7.9,2.4-9.6,9.8-1.9,5.4-3.7-4.6-5.7-10.4-3.7c-8.3,2.9-13.6,3.1-16.9,3.9-3.3.8-5.4,8.9-3,11.4,2.4,2.4,9.6,2.9,11.1,6.2,1.6,3.3,6.8,5.4,9.7,3.9s3.1,1.8,3.9,3.1,4.1,7,7.4,8.7,0,6.6,2.1,10.3c1.4,2.5.5,3.2,1.5,3.3h.4Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkGlobe);
export default __webpack_public_path__ + "static/media/dark-globe.904e2189bd012af05c16974283782c32.svg";
export { ForwardRef as ReactComponent };